import { type ErrorComponentProps, useRouter } from '@tanstack/react-router';
import { ErrorState } from '@/components/ui/error-state';

export function RouteError({ error, reset }: ErrorComponentProps) {
  const router = useRouter();
  return (
    <ErrorState
      error={error}
      title="Something went wrong"
      onRetry={() => {
        reset();
        void router.invalidate();
      }}
    />
  );
}
